module.exports = __webpack_public_path__ + "static/media/chevron-down.68022434.svg";